import { render, staticRenderFns } from "./PurchaseInvoicesLinesTable.vue?vue&type=template&id=5a3bf322&scoped=true&"
import script from "./PurchaseInvoicesLinesTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoicesLinesTable.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseInvoicesLinesTable.vue?vue&type=style&index=0&id=5a3bf322&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3bf322",
  null
  
)

export default component.exports